"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PfApiUtil = void 0;
const resources_1 = require("./resources");
const apiconnection_1 = require("./apiconnection");
const dto_1 = require("./dto");
class PfApiUtil {
  constructor(DEVICE_TYPE, LS_PREFIX) {
    this.DEVICE_TYPE = DEVICE_TYPE;
    this.LS_PREFIX = LS_PREFIX;
    this.loading = false;
    this.avatar = new dto_1.ImageInlineData();
    this.background = new dto_1.ImageInlineData();
    if (!LS_PREFIX) {
      this.LS_PREFIX = DEVICE_TYPE;
    }
    // Letzten Zustand wiederherstellen
    const apidata = localStorage.getItem(this.LS_PREFIX);
    if (apidata) {
      this.deviceResource = new resources_1.PfDeviceResource(JSON.parse(apidata));
    } else {
      const device = new dto_1.Device();
      device.deviceType = this.DEVICE_TYPE;
      this.deviceResource = new resources_1.PfDeviceResource(device);
    }
    this.apiConnection = new apiconnection_1.ApiConnection(); // kein Autoconnect machen!
    this.apiConnection.setDevice(this.deviceResource);
  }
  get apiHost() {
    return this.deviceResource.apiData.apiHost;
  }
  /**
   * @param apiLocation Der Api-Endpoint, etwa 'https://sync.projectfacts.de/api'
   */
  set apiHost(apiLocation) {
    this.deviceResource.apiData.apiHost = apiLocation;
  }
  /** Frisches Login per email/passwort */
  emailLogin(email, password) {
    return __awaiter(this, void 0, void 0, function* () {
      const regDat = apiconnection_1.RegistrationData.registerByEmail(email, password);
      this.apiConnection.setDevice(this.deviceResource);
      this.deviceResource = yield this.apiConnection.register(regDat);
      this.storeLS();
      return this.deviceResource;
    });
  }
  /** Frisches Login per autologin */
  autoLogin(autologin) {
    return __awaiter(this, void 0, void 0, function* () {
      const regDat = apiconnection_1.RegistrationData.registerByAppAutoLogin(this.apiHost, autologin);
      this.apiConnection.setDevice(this.deviceResource);
      this.deviceResource = yield this.apiConnection.register(regDat);
      this.storeLS();
      return this.deviceResource;
    });
  }
  /** Frisches Login per autologin */
  shortTimePasswordLogin(password) {
    return __awaiter(this, void 0, void 0, function* () {
      const regDat = apiconnection_1.RegistrationData.registerByShorttimePassword(this.apiHost, password);
      this.apiConnection.setDevice(this.deviceResource);
      this.deviceResource = yield this.apiConnection.register(regDat);
      this.storeLS();
      return this.deviceResource;
    });
  }
  register(regData) {
    return __awaiter(this, void 0, void 0, function* () {
      this.deviceResource = yield this.apiConnection.register(regData);
      this.storeLS();
      return this.deviceResource;
    });
  }
  logout() {
    return new Promise((rslvfn, rjctfn) => __awaiter(this, void 0, void 0, function* () {
      try {
        yield this.deviceResource.del(this.apiConnection);
        this.deviceResource.apiData = new dto_1.Device();
        this.storeLS();
        rslvfn(true);
      } catch (e) {
        rjctfn(e);
      }
    }));
  }
  isConnectable() {
    return this.apiHost != null && this.deviceResource != null && this.deviceResource.apiData._id != null;
  }
  /** Mit vorhandenem Geräte-Token verbinden */
  reconnect() {
    return new Promise((rslvfn, rjctfn) => {
      // Wir testen/aktualisieren die Verbindung zur API
      this.apiConnection.connect(this.deviceResource, 'https').then(() => {
        // Falls sich etwas geändert hat, lieber mal speichern:
        this.storeLS();
        rslvfn(this.deviceResource);
      }).catch(e => rjctfn(e));
    });
  }
  load(resource) {
    return resource.load(this.apiConnection);
  }
  loadTemplate(resource) {
    return resource.loadTemplate(this.apiConnection);
  }
  loadImageData(url) {
    return this.apiConnection.loadImageData({
      src: null,
      href: url
    });
  }
  loadFile(url, progressfunction) {
    return this.apiConnection.loadFile(url, progressfunction);
  }
  getAvatar() {
    return new Promise((reslvfn, rjctfn) => {
      this.lazyLoadAvatarAndBackground().then(ab => reslvfn(ab[0])).catch(e => rjctfn(e));
    });
  }
  getBackground() {
    return new Promise((reslvfn, rjctfn) => this.lazyLoadAvatarAndBackground().then(ab => reslvfn(ab[1])).catch(e => rjctfn(e)));
  }
  getUser(forceReload) {
    return new Promise((rslvfn, rjrctfn) => __awaiter(this, void 0, void 0, function* () {
      const reloadNeeded = forceReload || !this.user || this.user._id !== this.deviceResource.apiData.user.value;
      if (reloadNeeded) {
        try {
          if (this.deviceResource.apiData.user) {
            const userResource = new resources_1.PfUserResource(new dto_1.User());
            userResource.apiData._id = this.deviceResource.apiData.user.value;
            yield this.load(userResource);
            this.user = userResource.apiData;
          } else {
            this.user = null;
          }
        } catch (e) {
          rjrctfn(e);
          return;
        }
      }
      rslvfn(this.user);
    }));
  }
  getContact(forceReload) {
    return new Promise((rslvfn, rjrctfn) => __awaiter(this, void 0, void 0, function* () {
      const reloadNeeded = forceReload || !this.contact || this.contact._id !== this.deviceResource.apiData.user.value;
      if (reloadNeeded) {
        try {
          if (this.deviceResource.apiData.user) {
            const contactResource = new resources_1.PfContactResource(new dto_1.Contact());
            contactResource.apiData._id = this.deviceResource.apiData.user.value;
            yield this.load(contactResource);
            this.contact = contactResource.apiData;
          } else {
            this.contact = null;
          }
        } catch (e) {
          rjrctfn(e);
          return;
        }
      }
      rslvfn(this.contact);
    }));
  }
  getExternalaccess(forceReload) {
    return new Promise((rslvfn, rjrctfn) => __awaiter(this, void 0, void 0, function* () {
      // Nur mit dem Kontakt , können wir den externen Zugang laden
      yield this.getContact(forceReload);
      const hasEa = this.contact && this.contact.externalaccess && this.contact.externalaccess.value;
      const reloadNeeded = hasEa && (forceReload || !this.externalaccess || this.externalaccess._id !== this.contact.externalaccess.value);
      if (reloadNeeded) {
        try {
          if (this.contact.externalaccess.value) {
            const eaRespource = new resources_1.PfExternalaccessResource(new dto_1.Externalaccess());
            eaRespource.apiData._id = this.contact.externalaccess.value;
            yield this.load(eaRespource);
            this.externalaccess = eaRespource.apiData;
          } else {
            this.externalaccess = null;
          }
        } catch (e) {
          rjrctfn(e);
          return;
        }
      }
      rslvfn(this.externalaccess);
    }));
  }
  lazyLoadAvatarAndBackground(forceReload) {
    return new Promise((rslvfn, rjrctfn) => __awaiter(this, void 0, void 0, function* () {
      yield this.getUser(forceReload); // Sicherstellen, dass der User vorhanden und aktuell ist
      const reloadNeeded =
      // Nutzer hat ein AvatarBild was von unserem abweicht
      this.user.image && this.user.image.href !== this.avatar.href
      // Nutzer hat ein HintergrundBild was von unserem abweicht
      || this.user.background && this.user.background.href !== this.background.href;
      if (reloadNeeded) {
        // Update des Hintergrundes
        if (!this.user.background || !this.user.background.href) {
          this.background.href = null;
          this.background.src = null;
        } else {
          this.background = yield this.loadImageData(this.user.background.href);
        }
        // Update des Avatars
        if (!this.user.image || !this.user.image.href) {
          this.avatar.href = null;
          this.avatar.src = null;
        } else {
          this.avatar = yield this.loadImageData(this.user.image.href);
        }
      }
      rslvfn([this.avatar, this.background]);
    }));
  }
  storeLS() {
    localStorage.setItem(this.LS_PREFIX, JSON.stringify(this.deviceResource.apiData));
  }
  uploadFile(location, file, progressfunction, additionalFormData) {
    return this.apiConnection.storeFile(location, file, 'POST', progressfunction, additionalFormData);
  }
  uploadImageData(location, base64DataUrl, progressfunction, filename, description) {
    const imageData = new dto_1.Image();
    imageData.filename = filename;
    imageData.description = description;
    imageData.data = base64DataUrl;
    return this.apiConnection.storeDTO(location, imageData, true, progressfunction);
  }
  /**
   * macht ein creat, wenn keine _id gesezt ist
   * beispiel für URL: '/ticket'
   * @param data Objekt mit Daten, entweder ein PfDTO oder eine Resource mit apiData
   * @param url Basis URL, nur benötigt wenn data ein PfDTO ist
   * @returns ein PfDTO von unserer Api oder null, wenn der Request erfolgreich war, aber das Ergebnis kein JSON war
   */
  store(data, url) {
    return __awaiter(this, void 0, void 0, function* () {
      const isCreate = data instanceof dto_1.PfDTO ? !data._id : !data.apiData._id;
      let storedData = '';
      if (data instanceof dto_1.PfDTO) {
        if (!url || url.length === 0 || !url.startsWith('/')) {
          throw new Error('with DTO provided we need a base Url, and needs to start with \'/\'');
        }
        storedData = yield this.apiConnection.storeDTO(this.apiConnection.getConnectableResource().getAPIHost() + url, data, isCreate);
      } else if (data instanceof resources_1.PfItemResource) {
        const url = isCreate ? data.getAPICreateURL() : data.getAPILoadURL(this.apiConnection.getConnectableResource());
        storedData = yield this.apiConnection.storeDTO(url, data.apiData, isCreate);
      } else {
        throw new Error('need either a PfDTO or a PfResource');
      }
      try {
        return JSON.parse(storedData);
      } catch (error) {
        return null;
      }
    });
  }
}
exports.PfApiUtil = PfApiUtil;
